import {useId} from "react";
import styled from "@emotion/styled";

import {Checkbox} from "@pg-design/checkbox-module";
import {OfferType} from "@pg-rp/common-types";

import {PropertyHouseStoreys} from "../../offer/detail/constants/PropertyHouseStoreys";
import {FloorChoice} from "../../real_estate/types/FloorChoice";
import {SearchFilterLabel} from "./filters/SearchFilterLabel";

interface IOwnProps {
    error?: string[];
    name: string;
    label?: string;
    id: string;
    onChange: (fieldName: string, value: number[]) => void;
    value: number[];
    offerType?: OfferType;
}

export const FloorChoicesSwitch = (props: IOwnProps) => {
    const options = props.offerType === OfferType.HOUSE ? floorOptionsForHouse : floorOptions;
    // Several instances can be mounted at once (e.g. the hidden desktop copy and the mobile "Filtry" dialog on the offer card),
    // so option ids need a per-instance part; otherwise a label's `for` points at the first matching input in the document.
    const instanceId = useId();

    const onOptionSelect = (name: string) => {
        const selectedOptionValue = options.find((el) => el.label === name)?.value;

        if (!selectedOptionValue) {
            return;
        }
        const valueSelected = props.value.includes(selectedOptionValue);

        if (!valueSelected) {
            props.onChange(props.name, [...props.value, selectedOptionValue]);
        }

        if (valueSelected) {
            const filtered = props.value.filter((floorChoiceValue: number) => floorChoiceValue !== selectedOptionValue);
            props.onChange(props.name, [...filtered]);
        }
    };

    return (
        <>
            {props.label ? <SearchFilterLabel htmlFor={props.id} label={props.label} /> : null}
            <FloorChoicesHolder>
                {options.map((floorOption) => {
                    const check = props.value.includes(floorOption.value);
                    return (
                        <Checkbox
                            id={`floor-choice-${instanceId}-${floorOption.value}`}
                            key={floorOption.value}
                            labelContent={floorOption.label}
                            name={floorOption.label}
                            checked={check}
                            value={floorOption.value}
                            onChange={onOptionSelect}
                        />
                    );
                })}
            </FloorChoicesHolder>
        </>
    );
};

export const floorOptionsForHouse = [
    {label: "Parterowy", value: PropertyHouseStoreys.SINGLE_STOREY},
    {label: "Piętrowy", value: PropertyHouseStoreys.MULTI_STOREY}
];

export const floorOptions = [
    {label: "Parter", value: FloorChoice.GROUND},
    {label: "Parter z ogródkiem", value: FloorChoice.GROUND_WITH_GARDEN},
    {label: "Niskie piętra (1-4)", value: FloorChoice.LOW_LEVELS},
    {label: "Wysokie piętra (5+)", value: FloorChoice.HIGH_LEVELS},
    {label: "Ostatnie piętro", value: FloorChoice.LAST_LEVEL},
    {label: "Ostatnie piętro z tarasem", value: FloorChoice.LAST_LEVEL_WITH_TERRACE}
];

const FloorChoicesHolder = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    flex-shrink: 0;
    flex-grow: 0;

    > div {
        margin-bottom: 1.5rem;
    }
`;
import {useId} from "react";
import styled from "@emotion/styled";

import {Checkbox} from "@pg-design/checkbox-module";
import {OfferType} from "@pg-rp/common-types";

import {PropertyHouseStoreys} from "../../offer/detail/constants/PropertyHouseStoreys";
import {FloorChoice} from "../../real_estate/types/FloorChoice";
import {SearchFilterLabel} from "./filters/SearchFilterLabel";

interface IOwnProps {
    error?: string[];
    name: string;
    label?: string;
    id: string;
    onChange: (fieldName: string, value: number[]) => void;
    value: number[];
    offerType?: OfferType;
}

export const FloorChoicesSwitch = (props: IOwnProps) => {
    const options = props.offerType === OfferType.HOUSE ? floorOptionsForHouse : floorOptions;
    // Several instances can be mounted at once (e.g. the hidden desktop copy and the mobile "Filtry" dialog on the offer card),
    // so option ids need a per-instance part; otherwise a label's `for` points at the first matching input in the document.
    const instanceId = useId();

    const onOptionSelect = (name: string) => {
        const selectedOptionValue = options.find((el) => el.label === name)?.value;

        if (!selectedOptionValue) {
            return;
        }
        const valueSelected = props.value.includes(selectedOptionValue);

        if (!valueSelected) {
            props.onChange(props.name, [...props.value, selectedOptionValue]);
        }

        if (valueSelected) {
            const filtered = props.value.filter((floorChoiceValue: number) => floorChoiceValue !== selectedOptionValue);
            props.onChange(props.name, [...filtered]);
        }
    };

    return (
        <>
            {props.label ? <SearchFilterLabel htmlFor={props.id} label={props.label} /> : null}
            <FloorChoicesHolder>
                {options.map((floorOption) => {
                    const check = props.value.includes(floorOption.value);
                    return (
                        <Checkbox
                            id={`floor-choice-${instanceId}-${floorOption.value}`}
                            key={floorOption.value}
                            labelContent={floorOption.label}
                            name={floorOption.label}
                            checked={check}
                            value={floorOption.value}
                            onChange={onOptionSelect}
                        />
                    );
                })}
            </FloorChoicesHolder>
        </>
    );
};

export const floorOptionsForHouse = [
    {label: "Parterowy", value: PropertyHouseStoreys.SINGLE_STOREY},
    {label: "Piętrowy", value: PropertyHouseStoreys.MULTI_STOREY}
];

export const floorOptions = [
    {label: "Parter", value: FloorChoice.GROUND},
    {label: "Parter z ogródkiem", value: FloorChoice.GROUND_WITH_GARDEN},
    {label: "Niskie piętra (1-4)", value: FloorChoice.LOW_LEVELS},
    {label: "Wysokie piętra (5+)", value: FloorChoice.HIGH_LEVELS},
    {label: "Ostatnie piętro", value: FloorChoice.LAST_LEVEL},
    {label: "Ostatnie piętro z tarasem", value: FloorChoice.LAST_LEVEL_WITH_TERRACE}
];

const FloorChoicesHolder = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    flex-shrink: 0;
    flex-grow: 0;

    > div {
        margin-bottom: 1.5rem;
    }
`;
